import React, { useRef } from "react";
import { motion, useMotionValue, useTransform, useAnimationFrame } from "framer-motion";
import matrix from "../../images/MatrixRainingCode.mp4"; // Fond vidéo

const keywords = [
   "React",  "Node JS", "JavaScript",  "HTML", "CSS", "Redux", "Next JS", "Express","JWT", "Vercel", "MongoDB","PHP",  "JQuery", "AJAX",
  "MySQL", "SQL Server", "Visual Studio Code", "GIT", "Code Igniter", "Wordpress", "Laravel", "C#" 
];

const perspective = 500;
const radiusZ = 300;
const minRadiusX = 40;
const maxRadiusX = window.screen.width/2-300;
const minFontSize = 12;
const maxFontSize = 48; // Réduit la taille des mots-clés
const decalerGauche = 120; 

function RotatingKeyword({ word, index, total }) {
  const angle = useMotionValue(0);

  const baseY = useTransform(angle, () => {
    const progress = index / total;
    return -220 + progress * 450;
  });

  const animatedY = useMotionValue(0);
  useAnimationFrame((t) => {
    angle.set(t / 1500);
    animatedY.set(Math.sin((t / 1500) + index) * 25);
  });

  const y = useTransform([baseY, animatedY], ([base, anim]) => base + anim);

  const radiusX = useTransform(baseY, (yVal) => {
    const ratio = (yVal + 250) / 500;
    return minRadiusX + (1 - ratio) * (maxRadiusX - minRadiusX);
  });

  const x = useTransform(angle, (a) => radiusX.get() * Math.cos(a + index)- decalerGauche);
  const z = useTransform(angle, (a) => radiusZ * Math.sin(a + index));
  const scale = useTransform(z, (zVal) => 1 + 0.5 * (perspective / (perspective + zVal)));
  const opacity = useTransform(z, (zVal) => Math.max(0.3, 1 - zVal / 1000));
  const fontSize = useTransform(baseY, (yVal) => {
    const ratio = 1 - (yVal + 250) / 500;
    const size = minFontSize + ratio * (maxFontSize - minFontSize);
    return `${size}px`;
  });

  return (
    <motion.div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        x,
        y,
        scale,
        opacity,
        transformStyle: "preserve-3d",
        fontSize,
        fontWeight: "bold",
        color: "white",
        textShadow: "0 0 8px white",
        cursor: "grab",
      }}
    >
      {word}
    </motion.div>
  );
}

export default function PageHome() {
  const containerRef = useRef(null);

  return (
    <div
      ref={containerRef}
      className="relative w-screen h-screen overflow-hidden text-white font-sans"
    >
      {/* Fond vidéo */}
      <div className="absolute top-0 left-0 w-full h-full z-0">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover"
        >
          <source src={matrix} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

      </div>

      {/* Mots-clés en rotation */}
      {keywords.map((word, idx) => (
        <RotatingKeyword key={idx} word={word} index={idx} total={keywords.length} />
      ))}

    </div>
  );
}
